import { Navigate, useLocation } from 'react-router-dom';
import { useAbility } from '@/ability/AbilityProvider';
import { parsePermission } from '@/ability/constants';

const RequireAbility = ({
    can = [],
    children,
    fallback = '/not-authorized',
    fallbackElement = null,
}) => {
    const ability = useAbility();
    const location = useLocation();

    const isAllowed = (() => {
        if (!Array.isArray(can) || can.length === 0) return true;
        return can.some((entry) => {
            if (typeof entry === 'string') {
                const parsed = parsePermission(entry);
                if (!parsed) return false;
                const [action, subject] = parsed;
                return ability?.can(action, subject);
            }
            const [action, subject] = entry;
            return ability?.can(action, subject);
        });
    })();

    if (!isAllowed) {
        if (fallbackElement) return fallbackElement;
        return <Navigate to={fallback} state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAbility;
